import { FunctionComponent } from "react";

const EmptyContent: FunctionComponent<{
  desc?: string;
  className?: string;
}> = function ({ desc, className = "" }) {
  return (
    <div className={`relative w-[287px] h-[217px] ${className}`}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 283 217"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M283 141.5C283 219.648 219.648 216.5 141.5 216.5C63.3517 216.5 0 219.648 0 141.5C0 63.3517 63.3517 0 141.5 0C219.648 0 283 63.3517 283 141.5Z"
          fill="#EEF4FC"
        />
      </svg>
      <div className="w-full h-full flex flex-col items-center justify-center absolute top-0 left-0">
        <svg
          width="53"
          height="52"
          viewBox="0 0 53 52"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.5 0C21.3577 0 16.3309 1.52487 12.0552 4.38179C7.77951 7.23871 4.44702 11.2994 2.47914 16.0502C0.511265 20.8011 -0.00362134 26.0288 0.999594 31.0723C2.00281 36.1159 4.47907 40.7486 8.11524 44.3848C11.7514 48.0209 16.3842 50.4972 21.4277 51.5004C26.4712 52.5036 31.6989 51.9887 36.4498 50.0209C41.2007 48.053 45.2613 44.7205 48.1182 40.4448C50.9751 36.1691 52.5 31.1423 52.5 26C52.4868 19.1084 49.7433 12.5029 44.8702 7.62982C39.9971 2.75674 33.3916 0.0132149 26.5 0ZM17.5 24C16.9067 24 16.3266 23.8241 15.8333 23.4944C15.34 23.1648 14.9554 22.6962 14.7284 22.1481C14.5013 21.5999 14.4419 20.9967 14.5577 20.4147C14.6734 19.8328 14.9591 19.2982 15.3787 18.8787C15.7982 18.4591 16.3328 18.1734 16.9147 18.0576C17.4967 17.9419 18.0999 18.0013 18.6481 18.2284C19.1962 18.4554 19.6648 18.8399 19.9944 19.3333C20.3241 19.8266 20.5 20.4067 20.5 21C20.5 21.7956 20.1839 22.5587 19.6213 23.1213C19.0587 23.6839 18.2957 24 17.5 24ZM35.5 24C34.9067 24 34.3266 23.8241 33.8333 23.4944C33.34 23.1648 32.9554 22.6962 32.7284 22.1481C32.5013 21.5999 32.4419 20.9967 32.5577 20.4147C32.6734 19.8328 32.9591 19.2982 33.3787 18.8787C33.7982 18.4591 34.3328 18.1734 34.9147 18.0576C35.4967 17.9419 36.0999 18.0013 36.6481 18.2284C37.1962 18.4554 37.6648 18.8399 37.9944 19.3333C38.3241 19.8266 38.5 20.4067 38.5 21C38.5 21.7956 38.1839 22.5587 37.6213 23.1213C37.0587 23.6839 36.2957 24 35.5 24Z"
            fill="#87B5FF"
          />
        </svg>
        {desc && <div className="mt-3 text-gray1 font-normal">{desc}</div>}
      </div>
    </div>
  );
};

export default EmptyContent;
